import { Flex } from "@chakra-ui/react";

const InvoiceDescription = ({ description }) => {
  return (
    <Flex alignItems="center" textAlign="left" mb={2} fontWeight={500}>
      <span style={{ textTransform: "uppercase" }}>{description || "Invoice"}</span>
    </Flex>
  );
};

export default InvoiceDescription;
